import { action, observable, runInAction } from 'mobx'
import BaseStore from '@store/table'
import Api from '@api/xiu_yan/contentDataApi'
import MarketApi from '@api/marketing'

class Store extends BaseStore {
  tabArray = ['套餐', '案例', '款式']
  @observable tab = '0'

  @observable overviewTab = '0'
  @observable trendTab = '7'
  @observable typeTab = '1'

  @observable detailTab = '1'

  @observable productPrice = {}
  @observable showProtocolModal = false

  @action
  setStoreData = (type, value) => {
    this[type] = value
  }

  @action
  changValue = type => e => {
    this[type] = e.target.value

    if (type == 'overviewTab') {
      this.getOverview()
    }

    if (type == 'trendTab') {
      this.getTrend()
    }

    if (type == 'detailTab') {
      this.$getList()
    }
  }

  @action
  changTab = value => {
    this.tab = value
    this.getOverview()
    this.getTrend()
    this.$getList()
  }

  @action
  changField = value => {
    this.typeTab = value
    this.getTrend()
  }

  @observable overview = {}
  @action
  getOverview = async () => {
    const timeArray = ['1', '7', '30', '60']
    const { overviewTab, tab } = this
    let { data, success } = await Api.overview({
      days: timeArray[overviewTab],
      type: tab
    })
    if (success) {
      runInAction(() => {
        this.overview = data || {}
      })
    } else {
      this.overview = {}
    }
  }

  @observable trend = []
  @action
  getTrend = async () => {
    const { trendTab, typeTab, tab } = this
    let {
      data: { list },
      success
    } = await Api.trend({ days: trendTab, tab: typeTab, type: tab })
    if (success) {
      runInAction(() => {
        this.trend = list || []
      })
    } else {
      this.trend = []
    }
  }

  $listApi = Api.detail
  $getParams = () => {
    const { detailTab, tab } = this
    const { ...rest } = this.$params

    const params = {
      type: tab,
      days: detailTab
    }

    const { order = 'descend', field = 'ctr' } = this.$sorter

    return {
      order_field: field,
      order: order == 'descend' ? 'desc' : 'asc',
      ...rest,
      ...params
    }
  }

  @action
  getDetail = async () => {
    const { data, success } = await MarketApi.getShopProductPrice()
    if (success) {
      this.productPrice = data || {}
    }
  }
}
export default Store
